import React, { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { MainLayout } from "../layout/mainLayout";
import { LoadingIndicator } from "../framework/loadingIndicatorNew";
import { useInterval } from "usehooks-ts";
import { NotificationsTable } from "./NotificationsTable";
import { useAppDispatch, useAppSelector } from "../../framework/customStore";
import { fetchEmployees } from "../../store/employeeSlice";
import { fetchNotifications } from "../../store/notificationSlice";
import { useAppOptionValue } from "../../hooks/useAppOption";
import {
    optionOwnerHasTransportEnabled,
    optionOwnerHasTransportNotificationsEnabled,
} from "../../models/common/consts";

const REFETCH_INTERVAL = 1000 * 60;

export const NotificationsListMain = () => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();

    const [hasTransportEnabled] = useAppOptionValue<boolean>(
        optionOwnerHasTransportEnabled
    );
    const [hasTransportNotificationsEnabled] = useAppOptionValue<boolean>(
        optionOwnerHasTransportNotificationsEnabled
    );
    const hasTransportNotifications =
        hasTransportEnabled && hasTransportNotificationsEnabled;

    const employees = useAppSelector((state) => state.employees.employees);
    const loading = useAppSelector((state) => state.notifications.loading);
    const transportNotifications = useAppSelector(
        (state) => state.notifications.transportNotifications
    );
    const desktopNotifications = useAppSelector(
        (state) => state.notifications.desktopNotifications
    );

    const fetchAll = useCallback(
        () =>
            dispatch(
                fetchNotifications({
                    fetchDesktop: true,
                    fetchTransport: !!hasTransportNotifications,
                })
            ),
        [dispatch, hasTransportNotifications]
    );

    useInterval(fetchAll, REFETCH_INTERVAL);

    useEffect(() => {
        void fetchAll();
    }, [fetchAll]);

    useEffect(() => {
        if (employees.length === 0) {
            dispatch(fetchEmployees() as any);
        }
    }, [employees]);

    if (!employees) {
        return <LoadingIndicator tooltip={t("common.loading")} />;
    }

    return (
        <MainLayout noContainer>
            <>
                {loading && (
                    <LoadingIndicator tooltip={t("common.loading")} />
                )}
                <NotificationsTable
                    notifications={transportNotifications}
                    desktopNotifications={desktopNotifications}
                    fetchNotifications={fetchAll}
                    hasTransportOrdersEnabled={!!hasTransportNotifications}
                />
            </>
        </MainLayout>
    );
};
